const styles = theme => ({
  searchBar: {
    backgroundColor: theme.palette.secondary.light,
    marginLeft: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  searchIcon: {
    color: "black",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    top: 6,
    position: "relative"
  },
  searchInput: {
    fontSize: 14
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Organizations/styles.js